import { z } from "zod"

/**
 * El campo acepta DOS cosas: el correo del personal interno de RJ y el usuario
 * del permisionario ("TransportesRalla"). Por eso ya no valida formato de
 * correo: el usuario del portal no lo tiene, y con `.email()` el formulario lo
 * rechazaba antes de llegar al servidor. Ver `src/lib/portal-login.ts`.
 */
const  signInSchema = z.object({
  email: z.string().trim().min(1, "Usuario o correo requerido"),
  password: z.string().trim().min(1, "Contraseña requerida").min(6, "La contraseña debe tener al menos 6 caracteres"),
})



export { signInSchema }
